import React from "react";
import {ListGroup, Button } from 'reactstrap';

import InvoiceTimelineItem from "./timeline-item";
import InvoiceResultsBreakdown from "./result-breakdown";
import ServerPaginatedTable from "../utils/pagination.server";
import DownloadIcon from 'react-icons/lib/md/cloud-download';

const TimelineStructure = ({data, toggleInvoiceModal, getInvoiceIssuers}) => (
    <ListGroup>
        {
            data.map((item, i) =>
                <InvoiceTimelineItem getInvoiceIssuers={getInvoiceIssuers} toggleInvoiceModal={ toggleInvoiceModal } item={item} key={i} />
            )}
    </ListGroup>
);

class InvoiceTimeline extends React.Component {
     render() {
        const { reports, toggleInvoiceModal, handleReportDownload, currentPage, pageDataCallback, pageSize, totalCount, searchByProcessName, invoiceReconciliationFiles, getInvoiceIssuers} = this.props;
        //  const  processNameCounter = new Map([...new Set(processName)].map(item => [item, reports.filter(i => i.ProcessName === item).length]));
         return (
            <div className="row">
                <div className="col-md-9 col-sm-12 mb-4">
                    <ServerPaginatedTable currentPage={currentPage} fetchMore={ pageDataCallback} target={<TimelineStructure getInvoiceIssuers={getInvoiceIssuers} toggleInvoiceModal={toggleInvoiceModal} data={reports}/>} pageSize={pageSize} totalCount={ totalCount }/>
                </div>
                <div className="col-md-3 col-sm-12 mb-4">
                    {
                        totalCount > 0 &&
                        <div className={'mb-2'}>
                            <Button style={{width: '100%'}} className="btn btn-avi-secondary" onClick={handleReportDownload}>
                                <DownloadIcon/> Download
                            </Button>
                        </div>
                    }

                    <InvoiceResultsBreakdown searchByProcessName={searchByProcessName} invoiceReconciliationFiles={invoiceReconciliationFiles}/>

                    {/*<InvoiceReportDownload positionFromBottom={`${positionFromBottom}px`} handleReportDownload={ handleReportDownload }/>*/}

                </div>
            </div>
        )
    }
}
export default InvoiceTimeline;



// WEBPACK FOOTER //
// ./src/views/invoice/timeline.js